import React from 'react';
import { Circle, Group } from 'react-konva';
import { isMobile } from 'react-device-detect';
import { color } from 'styles/settings';

export interface ContextMenuButtonProps {
  onClick: Function;
}

const defaultProps = {};

function ContextMenuButton(props: ContextMenuButtonProps) {
  return (
    <Group
      {...{
        [isMobile ? 'onTap' : 'onClick']: props.onClick,
      }}>
      <Circle radius={19} width={38} height={38} fill={color.brand.greenDark} />

      <Group>
        <Circle x={-8} radius={3} fill={color.neutral.white} />
        <Circle radius={3} fill={color.neutral.white} />
        <Circle x={8} radius={3} fill={color.neutral.white} />
      </Group>
    </Group>
  );
}

ContextMenuButton.defaultProps = defaultProps;

export default ContextMenuButton;
